const cs_messages = require('./cs/messages.json')

const CZECH_STRINGS = {
  translation: cs_messages
}

export default CZECH_STRINGS
